export enum SiteType {
  luckyBird = 0,
  project = 1,
  cms = 2,
  luckyBirdGlobal = 3,
}
